{
    "navbar": {
        "help_center": "Centre d'aide",
        "share_idea": "Partager une idée",
        "logout": "Déconnexion"
    },
    "languages": {
        "title": "Langues",
        "explanation": "Vous pouvez remplacer la langue de votre interface par l'une des langues ci-dessous",
        "de": "Deutsch",
        "fr": "Français",
        "en": "English",
        "it": "Italiano",
        "es": "Español"
    },
    "form": {
        "submit": "Valider",
        "cancel": "Annuler",
        "errors": {
            "required": "Ce champ est requis"
        }
    },
    "menu": {
        "request_manager": {
            "title": "Request Manager",
            "pipeline": "Pipeline",
            "todo": "À faire",
            "inbox": "Boîte de réception",
            "message_templates": "Modèles de messages"
        },
        "offer_manager": {
            "title": "Offer Manager",
            "itineraries": "Itinéraires en Ligne"
        },
        "cash_manager": {
            "title": "Cash Manager",
            "accounting": "Comptabilité"
        },
        "insights": {
            "title": "Insights",
            "statistics": "Statistiques",
            "customer_satisfaction": "Satisfaction Client",
            "better_trip_index": "Better Trip Index"
        },
        "tipi": {
            "title": "Trip Planner",
            "library": "Bibliothèque"
        },
        "tools": {
            "title": "Resources Center",
            "partner_connect": "Partner Connect"
        },
        "agency_manager": {
            "title": "Agency Manager",
            "main_contacts": "Contacts Principaux",
            "active_accounts": "Comptes Actifs",
            "agency_capacity": "Capacité de l'agence",
            "legal_information": "Informations légales"
        }
    }
}
